import { Reset } from './generic';

export const COST_CENTER_REPORT_SUCCESS = 'COST_CENTER_REPORT_SUCCESS';
export const COST_CENTER_REPORT_ERROR = 'COST_CENTER_REPORT_ERROR';
export const COST_CENTER_REPORT_LOADING = 'COST_CENTER_REPORT_LOADING';

export interface ReportData {
  type: typeof COST_CENTER_REPORT_SUCCESS;
  data: Response;
}

export interface ReportLoading {
  type: typeof COST_CENTER_REPORT_LOADING;
  loading: boolean;
}

export interface ReportError {
  type: typeof COST_CENTER_REPORT_ERROR;
  loading: Response;
}

export type ReportActions = ReportData | ReportLoading | ReportError | Reset;

export const reportSuccess = (response: Response): ReportData => ({
  type: COST_CENTER_REPORT_SUCCESS,
  data: response,
});

export const reportError = () => ({ type: COST_CENTER_REPORT_ERROR });

export const reportLoading = (loading: boolean): ReportLoading => ({
  type: COST_CENTER_REPORT_LOADING,
  loading,
});
